import './section.css';
const HeroSection = () => {
  return (
    <div className="hero">
      <div className="overlay">
        <h1 className="title">Welcome To Tech Trove</h1>
        <p className="subtitle">Best electronic Products </p>
        <button className="hero-button">SHOP NOW</button>
      </div>
      </div>
      


  );
};

export default HeroSection;
